import { getSidebarIconButtonSx } from '@app/components/layout/sidenav/sidenav-colors';
import { useSidenavContext } from '@app/components/layout/sidenav/SidenavContext';
import { useIsImpersonationOn } from '@app/core/auth/impersonation/hooks/useIsImpersonationOn';
import { SettingsRoutes } from '@app/modules/settings/routing/SettingsRoutes';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { IconButton, Tooltip } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

const changeUserMessage = defineMessage({
  id: 'auth.userInfo.changeUser',
  defaultMessage: 'Cambiar usuario',
});

/**
 * Shortcut to the impersonation screen while a superadmin is acting as a client user.
 * Shown beside the tenant logo so the account popover is not required to switch users.
 */
export function SidenavChangeUserButton() {
  const isImpersonating = useIsImpersonationOn();
  const { collapsed } = useSidenavContext();
  const $t = useIntl().formatMessage;

  if (!isImpersonating || collapsed) {
    return null;
  }

  return (
    <Tooltip title={$t(changeUserMessage)} placement="bottom">
      <IconButton
        component={Link}
        to={SettingsRoutes.ROUTES.impersonation}
        size="small"
        data-cy="sidenav-change-user"
        sx={(theme) => ({
          ...getSidebarIconButtonSx(theme),
          p: 0.5,
        })}
      >
        <AdminPanelSettingsIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Tooltip>
  );
}
